module.exports = __webpack_public_path__ + "static/fourth-wave-d293476961a10822c774ce4b61622450.jpg";